<template>
  <div class="footer-area">
    <!-- Footer-Section start -->
    <footer>
      <div class="top_footer" id="contact">
        <!-- container start -->
        <div class="container">
          <!-- row start -->
          <div class="row">
            <span class="banner_shape1">
              <img src="images/banner-shape1.png" alt="image" />
            </span>
            <span class="banner_shape2">
              <img src="images/banner-shape2.png" alt="image" />
            </span>
            <span class="banner_shape3">
              <img src="images/banner-shape3.png" alt="image" />
            </span>
            <!-- footer link 1 -->
            <div class="col-lg-4 col-md-6 col-12">
              <div class="abt_side">
                <div class="logo">
                  <img src="images/footer_logo02.png" alt="image" />
                </div>
                <ul>
                  <li><a href="#" @click.prevent>support@example.com</a></li>
                  <li><a href="#" @click.prevent>+1-900-123 4567</a></li>
                </ul>
                <ul class="social_media">
                  <li>
                    <a href="#" @click.prevent><i class="icofont-facebook"></i></a>
                  </li>
                  <li>
                    <a href="#" @click.prevent><i class="icofont-twitter"></i></a>
                  </li>
                  <li>
                    <a href="#" @click.prevent><i class="icofont-instagram"></i></a>
                  </li>
                  <li>
                    <a href="#" @click.prevent><i class="icofont-pinterest"></i></a>
                  </li>
                </ul>
              </div>
            </div>

            <!-- footer link 2 -->
            <div class="col-lg-3 col-md-6 col-12">
              <div class="links">
                <h3>Useful Links</h3>
                <ul>
                  <li><router-link to="/">Home</router-link></li>
                  <!-- <li><a href="/about-us">About us</a></li> -->
                  <li><router-link to="/about-us">About Us</router-link></li>
                  <!-- <li><a href="/contact-us">Contact us</a></li> -->
                  <li><router-link to="/contact-us">Contact Us</router-link></li>
                </ul>
              </div>
            </div>

            <!-- footer link 3 -->
            <div class="col-lg-3 col-md-6 col-12">
              <div class="links">
                <h3>Help & Suport</h3>
                <ul>
                  <li>                    
                    <router-link to="/terms-and-conditions">Terms & Conditions</router-link>
                  </li>
                  <li><router-link to="/privacy-policy">Privacy Policy</router-link></li>
                  
                  <li><router-link to="/deletion-policy">Deletion Policy</router-link></li>
                  
                </ul>
              </div>
            </div>

            <!-- footer link 4 -->
            <div class="col-lg-2 col-md-6 col-12">
              <div class="try_out">
                <h3>Let’s Try Out</h3>
                <ul class="app_btn">
                  <li>
                    <a href="#">
                      <img src="images/appstore_blue02.png" alt="image" />
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <img src="images/googleplay_blue02.png" alt="image" />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- row end -->
        </div>
        <!-- container end -->
      </div>

      <!-- last footer -->
      <div class="bottom_footer">
        <!-- container start -->
        <div class="container">
          <!-- row start -->
          <div class="row">
            <div class="col-md-6">
              <p>© {{ cuYear }} Salt - All Rights Reserved.</p>
            </div>
            <div class="col-md-6">
              <p class="developer_text">
                Made with ❤️ by <a
                  href="https://codment.com/"
                  target="_blank"
                  rel="noopener"
                  >Codment</a
                >.
              </p>
            </div>
          </div>
          <!-- row end -->
        </div>
        <!-- container end -->
      </div>

      <!-- go top button -->
      <div class="go_top">
        <span><img src="images/go_top002.png" alt="image" /></span>
      </div>
    </footer>
    <!-- Footer-Section end -->
  </div>
</template>

<!-- <script>
export default {
  name: "FooterArea",

  data() {
    return {
      cuYear: "",
    };
  },
  mounted() {
    this.cuYear = new Date().getFullYear();
  },
};
</script> -->

<script setup>
import { ref, onMounted } from 'vue';

const cuYear = ref('');


const scriptUrls = [
 "/js/jquery.js",
  "/js/owl.carousel.min.js",
  "/js/bootstrap.min.js",
  "/js/aos.js",
 
 "/js/mainn.js",
 
  
  
]

const scriptLoaded = ref(false)



onMounted(() => {
  cuYear.value = new Date().getFullYear();


  loadScripts(scriptUrls).
    then(()=>{
        scriptLoaded.value=true       
    }).
    catch((error)=>{
        console.error('Error loading scripts:', error)
    })
});


// Script loader
async function loadScript(url) {
 
   return new Promise((resolve, reject)=>{
        const script = document.createElement('script')
        script.src= url
        script.onload = resolve
        script.onerror = reject
        document.head.appendChild(script)
    })
}

async function loadScripts(urls) {
  for (const url of urls) {
    await loadScript(url)
  }
}


</script>
<style scoped>
.top_footer .banner_shape1 {left:0}

.top_footer .banner_shape3 {
    top: 139px;
    right: 0px;
    animation: mymove 3s infinite;
}
.top_footer .banner_shape2 {
    top: -40px;
    right: 3%;
    animation: mymove 5s infinite;
}


footer .top_footer {
    /* background-color: #583BD3; */
    background-color: #181818;
    padding: 100px 0 100px 0;
    position: relative;
    overflow: hidden;
}
</style>


